import App from './App.svelte';
import '../public/global.css';
var app = new App({
	target: document.body,
});

export default app;
